import React, { Component } from "react";
import Headers from "../Layouts/HeaderReceptionist";
import axios from "axios";
import NextOfKin from "./NextOfKin";
import { useHistory } from "react-router-dom";
import $ from "jquery";
import { config } from "../_helpers/global";
import { ReceptionSidebar } from "../Layouts/ReceptionSidebar";

export class NewPatientDetails extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      Name: "",
      Dateofbirth: "",
      Age: "",
      Profession: "",
      MaritalStatus: "",
      Nationality: "",
      Address: "",
      Tel: "",
      Education: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {
    this.setState({
      uniqid: (Math.random() + 1).toString(36).substring(7),
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
    };
    event.preventDefault();
    console.log(this);
    axios
      .post(
        this.api_url+"reception/registerpatient/patient",
        this.state,
        { headers: headers }
      )
      .then((response) => {
        console.log(response);
        this.setState({ response: response });
        localStorage.setItem("patientId", response.data["patientid"]);
        if (response.data["status"] == "patient saved") {
          $(".alert-success").show();
          setTimeout(function (props) {
            window.location.href = "/input/next/kin";
            // this.props.history.push('/reception/dashboard')
          }, 1000);
        }
      })
      .catch((error) => {
        alert(error);
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const {
      Name,
      Dateofbirth,
      Age,
      Profession,
      MaritalStatus,
      Nationality,
      Address,
      Tel,
      Education,
    } = this.state;

    return (
      <div>
        {/* <NextOfKin userData = {response}/> */}
        <Headers />
        <ReceptionSidebar></ReceptionSidebar>

        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Patient Details
                  </p>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Name
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Name}
                      name="Name"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize">Age</h6>
                    <input
                      className="form-control"
                      name="Age"
                      onChange={this.handleChange}
                      value={Age}
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize">Nationality</h6>
                    <input
                      className="form-control"
                      type="text"
                      onChange={this.handleChange}
                      value={Nationality}
                      name="Nationality"
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">Profession</h6>
                    <input
                      className="form-control"
                      name="Profession"
                      onChange={this.handleChange}
                      value={Profession}
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize">Date of Birth</h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Dateofbirth}
                      name="Dateofbirth"
                      type="date"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Contact Information
                  </p>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Phone Number
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Tel}
                      name="Tel"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">Address</h6>
                    <input
                      className="form-control"
                      name="Address"
                      type="text"
                      onChange={this.handleChange}
                      value={Address}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Marital Status
                  </p>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Marital Status
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={MaritalStatus}
                      name="MaritalStatus"
                    >
                      <optgroup label="Marital Status">
                        <option selected></option>
                        <option value="single">Single</option>
                        <option value="married">Married</option>
                        <option value="divorced">Divorced</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Education
                  </p>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Education
                    </h6>
                    <input
                      className="form-control"
                      type="text"
                      onChange={this.handleChange}
                      value={Education}
                      name="Education"
                    />
                  </div>
                </div>
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Patient Registration Successful.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default NewPatientDetails;
